import theme from '@splashthat/sui/lib/theme';
import { TICKET_TYPE_STANDALONE, TICKET_TYPE_NESTED, TICKET_TYPE_ADD_ON } from '../../ticketType/selectors';

import {
    CENTER,
    SMALL,
    MEDIUM,
    LARGE,
    X_LARGE,
    SPACING_TIGHT,
    SPACING_STANDARD,
    SPACING_LOOSE,
    SPACING_DATA_MODE,
    SPACING_DATA_NODES_SEPARATION,
    SPACING_DATA_LABEL_SEPARATION,
} from './constants';

const { grayscale, primary, danger } = theme.palette;
/**
 * Default values for form renderer and form styling sidebar here.
 */
export const DEFAULT_FORM_FIELD_FONT_SIZE = 16;

export const DEFAULT_FONT = 'Lato';
export const DEFAULT_FONT_SIZE = 16;
export const DEFAULT_HEADLINE_SIZE = 20;
export const DEFAULT_BORDER_WIDTH = 1;
export const DEFAULT_BORDER_RADIUS = 4;

export const DEFAULT_FORM_BACKGROUND_COLOR = grayscale.white;

export const DEFAULT_HEADLINE_COLOR = grayscale.black;
export const DEFAULT_HEADLINE_POSITION = CENTER;

export const DEFAULT_ERRORS_COLOR = danger.main;

export const DEFAULT_TEXT_ELEMENT_POSITION = CENTER;

export const DEFAULT_INPUT_LABEL_COLOR = grayscale.black;
export const DEFAULT_INPUT_ANSWER_COLOR = grayscale.black;
export const DEFAULT_INPUT_HELPER_TEXT_COLOR = grayscale.black;
export const DEFAULT_INPUT_PLACEHOLDER_COLOR = grayscale.gray10;
export const DEFAULT_INPUT_BORDER_COLOR = grayscale.gray10;
export const DEFAULT_INPUT_BORDER_COLOR_HOVER = primary.main;
export const DEFAULT_INPUT_BORDER_COLOR_FOCUS = DEFAULT_INPUT_BORDER_COLOR_HOVER;
export const DEFAULT_INPUT_BACKGROUND_COLOR = grayscale.white;
export const DEFAULT_INPUT_BORDER_RADIUS = DEFAULT_BORDER_RADIUS;
export const DEFAULT_INPUT_BORDER_WIDTH = DEFAULT_BORDER_WIDTH;

export const DEFAULT_BUTTON_LABEL_COLOR = grayscale.white;
export const DEFAULT_BUTTON_BACKGROUND_COLOR = grayscale.black;
export const DEFAULT_BUTTON_BACKGROUND_COLOR_HOVER = grayscale.black;
export const DEFAULT_BUTTON_BORDER_COLOR = 'transparent';
export const DEFAULT_BUTTON_BORDER_COLOR_HOVER = DEFAULT_BUTTON_BORDER_COLOR;
export const DEFAULT_BUTTON_BORDER_COLOR_FOCUS = DEFAULT_BUTTON_BORDER_COLOR_HOVER;
export const DEFAULT_BUTTON_BORDER_RADIUS = DEFAULT_BORDER_RADIUS;
export const DEFAULT_BUTTON_BORDER_WIDTH = DEFAULT_BORDER_WIDTH;
export const DEFAULT_BUTTON_POSITION = CENTER;
export const DEFAULT_BUTTON_FONT_WEIGTH = 'normal';

export const DEFAULT_BANNER_SIZE = 12;

export const DEFAULT_LOGO_POSITION = CENTER;
export const DEFAULT_LOGO_SIZES = {
    [SMALL]: { label: 'Small', value: 4 },
    [MEDIUM]: { label: 'Medium', value: 5 },
    [LARGE]: { label: 'Large', value: 8 },
    [X_LARGE]: { label: 'X-Large', value: 10 },
};

// Close button
export const DEFAULT_FORM_BUTTON_COLOR = grayscale.gray10;
export const DEFAULT_FORM_BUTTON_COLOR_HOVER = grayscale.black;
export const DEFAULT_FORM_BUTTON_COLOR_FOCUS = DEFAULT_FORM_BUTTON_COLOR_HOVER;

export const DEFAULT_FORM_LINKS_COLOR = '#4999ef'; // CMS link color, not in Splash newer palette
export const DEFAULT_FORM_LINKS_COLOR_HOVER = DEFAULT_FORM_LINKS_COLOR;
export const DEFAULT_FORM_LINKS_COLOR_FOCUS = DEFAULT_FORM_LINKS_COLOR_HOVER;

export const DEFAULT_SPACING = {
    [SPACING_LOOSE]: {
        [SPACING_DATA_MODE]: SPACING_LOOSE,
        [SPACING_DATA_NODES_SEPARATION]: 56,
        [SPACING_DATA_LABEL_SEPARATION]: 16,
    },
    [SPACING_STANDARD]: {
        [SPACING_DATA_MODE]: SPACING_STANDARD,
        [SPACING_DATA_NODES_SEPARATION]: 46,
        [SPACING_DATA_LABEL_SEPARATION]: 14,
    },
    [SPACING_TIGHT]: {
        [SPACING_DATA_MODE]: SPACING_TIGHT,
        [SPACING_DATA_NODES_SEPARATION]: 26,
        [SPACING_DATA_LABEL_SEPARATION]: 12,
    },
};

export const DEFAULT_FORM_SESSION_TITLE_SIZE = 16;
export const DEFAULT_FORM_SESSION_BODY_SIZE = 14;
export const DEFAULT_FORM_SESSION_STEPPER_FONT_SIZE = 20;
export const DEFAULT_FORM_SESSION_ELEMENT_BORDER_COLOR = 'transparent';
export const DEFAULT_FORM_SESSION_ELEMENT_BORDER_WIDTH = 0;
export const DEFAULT_FORM_SESSION_TAG_BORDER_RADIUS = 20;
export const DEFAULT_FORM_SESSION_BADGE_BORDER_RADIUS = 4;
export const DEFAULT_FORM_SESSION_FONT_COLOR = grayscale.black;
export const DEFAULT_FORM_SESSION_TAG_BACKGROUND_COLOR = grayscale.black;
export const DEFAULT_FORM_SESSION_TAG_COLOR = grayscale.white;
export const DEFAULT_FORM_SESSION_BADGE_BACKGROUND_COLOR = grayscale.black;
export const DEFAULT_FORM_SESSION_BADGE_COLOR = grayscale.white;
export const DEFAULT_FORM_SECONDARY_BUTTON_BACKGROUND = 'transparent';
export const DEFAULT_FORM_SECONDARY_BUTTON_LABEL_COLOR = grayscale.black;
export const DEFAULT_FORM_SECONDARY_BUTTON_LABEL_COLOR_HOVER = grayscale.white;
export const DEFAULT_FORM_SECONDARY_BUTTON_BORDER_COLOR = grayscale.black;

// Ticket Styles
export const DEFAULT_TICKET_FONT_SIZE = 16;
export const DEFAULT_SMALL_TICKET_FONT_SIZE = 12;

export const DEFAULT_TICKET_NAME_COLOR = grayscale.black;
export const DEFAULT_TICKET_DESCRIPTION_COLOR = grayscale.black;
export const DEFAULT_TICKET_REMAINING_COLOR = grayscale.black;
export const DEFAULT_TICKET_DATE_TIME_COLOR = grayscale.black;
export const DEFAULT_TICKET_PRICE_COLOR = grayscale.black;

export const DEFAULT_TICKET_BACKGROUND_COLOR = grayscale.white;
export const DEFAULT_TICKET_BORDER_COLOR = grayscale.black;
export const DEFAULT_TICKET_BORDER_COLOR_HOVER = grayscale.black;
export const DEFAULT_TICKET_BACKGROUND_OPACITY = 1;

export const DEFAULT_TICKET_OVERLAY_COLOR = 'transparent';
export const DEFAULT_TICKET_OVERLAY_OPACITY = 0.3;

export const DEFAULT_TICKET_STYLE_CATEGORIES = [TICKET_TYPE_STANDALONE, TICKET_TYPE_NESTED, TICKET_TYPE_ADD_ON];
